import React from 'react';
import './index.scss';

const LocalisedLoader = props => {
    return <section className="localised-loader" />;
};

export default LocalisedLoader;
